// Module
var code = `<div id="wixOverlay" class="wix_overlay"> <div id="wixContent" class="wix_content">Tap on screen to experience AR</div> <button id="js-wixBack" class="wix_button">Back</button> </div>`;
// Exports
export default code;